import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';




interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const BusinessProcessSelect = ({ idSelector, onChange, label }: Props) => {

    const service = new BpmService();
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);

        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {

        service
            .getBusinessProcessCatalog(null, null, null, null, null, null)
            .subscribe((resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }

            });
    };
    return (
        <>
            <label>{label ?? "Roles proceso contractual:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBusinessProcess} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}